/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Household_Reason_Teen_LimitInputs */

const fr_household_reason_teen_limit = /** @type {(inputs: Household_Reason_Teen_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limite mensuelle de cours adultes atteinte`)
};

/**

* @param {Household_Reason_Teen_LimitInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_reason_teen_limit = /** @type {((inputs?: Household_Reason_Teen_LimitInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_Reason_Teen_LimitInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_reason_teen_limit(inputs)
});